module.exports = __webpack_public_path__ + "static/media/Checked.6b3d1337.svg";